export default __webpack_public_path__ + "static/media/exp.2b0e4b1c.svg";